"use strict";

// References
var alt = require("../alt");
var CompanyActions = require("../actions/CompanyActions");
var networking = require("../utils/Networking.js");
var Networking = new networking();
var _ = require("underscore");

var NotificationActions = require('../actions/NotificationActions');

var companyStore = alt.createStore(class CompanyStore {
    constructor() {
      this.bindActions(CompanyActions);
      this.departments = {};
      this.all_departments = {};
      this.types = {};
      this.locations = {};
      this.users = {};
      this.statuses = [];
      this.departmentDescendants = [];
      this.departmentAccess = [];
      this.roles = [];
      this.rolesPerUser = [];
      this.brands = [];
    }

    onClearNotifications() {
      var clearNotification = {
        "type": "",
        "message": "",
        "isActive": false,
        "color": "",
        "dismissAfter": 0
      };
      this.setState({notification: clearNotification});
    }

    // =============
    // GET FUNCTIONS
    // =============

    onGetCompanyData() {
      this.onGetDepartments();
      this.onGetDepartmentAccess();
      this.onGetTypes();
      this.onGetLocations();
      this.onGetUsers();
      this.onGetRoles();
      this.onGetRolesPerUser();
      this.onGetStatusList();
      this.onGetBrands();
    }

    onGetBrands() {
      var success = function(result) {
        this.setState({ 'brands': result });
      }.bind(this);

      var failure = function(error) {
        var notification = {
          title: 'Eitthvað fór úrskeiðis!',
          message: 'Tókst ekki að sækja vörumerki',
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET('brands/', success, failure);
    }

    onGetDepartments() {
      var success = function(result) {
        this.setState({"departments": result});
      }.bind(this);

      var failure = function(error) {
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að sækja deildir",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("departments/", success, failure);
    }

    onGetAllDepartments() {
      var success = function(result) {
        this.setState({"all_departments": result});
      }.bind(this);
      var failure = function(error) {
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að sækja deildir",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("all_departments/", success, failure);
    }

    onGetDepartmentAccess() {
      var success = function(result) {
        this.setState({"departmentAccess": result});
      }.bind(this);
      var failure = function(error) {
        console.error("getDepartmentAccess() fail", error)
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að aðgangsheimildir á deildir",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("departmentaccess/", success, failure);
    }

    onGetTypes() {
      var success = function(result) {
        this.setState({"types": result});
      }.bind(this);

      var failure = function(error) {
        console.error("getTypes() fail", error)
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að sækja tegundir",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("types/", success, failure);
    }

    onGetLocations() {
      var success = function(result) {
        this.setState({"locations": result});
      }.bind(this);

      var failure = function(error) {
        console.error("getLocations() fail", error)
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að sækja staðsetningar",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("locations/", success, failure);
    }

    onGetUsers() {
      var success = function(result) {
        this.setState({"users": result});
      }.bind(this);

      var failure = function(error) {
        console.error("getUsers() fail", error);
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Tókst ekki að sækja notendur",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.GET("users/", success, failure);
    }

    onGetRoles() {
        var success = function(result) {
          this.setState({"roles": result});
        }.bind(this);

        var failure = function(error) {
            console.error("getRoles() fail", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Tókst ekki að sækja hlutverk",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.GET("roles/", success, failure);
    }

    onGetRolesPerUser() {
        var success = function(result) {
            this.setState({"rolesPerUser": result});
        }.bind(this);

        var failure = function(error) {
            console.error("getRolesPerUser() fail", error)
            // TODO
           var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Tókst ekki að sækja hlutverk á notendur",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.GET("rolesperuser/", success, failure);
    }

    onGetStatusList() {

        var success = function(result) {
            this.setState({"statuses": result});
        }.bind(this);
        var failure = function(error) {
            console.error("getStatusList() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Tókst ekki að sækja stöður",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.GET("status/", success, failure);
    }

    // =============
    // ADD FUNCTIONS
    // =============

    onAddDepartment(data) {
      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: data.name+" bætt við í deildir",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetDepartments();
      }.bind(this);

      var failure = function(error) {
        console.error("addDepartment() fail", error)
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Ekki tókst að bæta "+data.name+" við deildir",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.POST("departments/", data, success, failure);
    }

    onAddBrand(data) {
      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: data.name + " bætt við í vörumerki",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetBrands();
      }.bind(this);

      var failure = function(error) {
        console.error("addBrand() fail", error)
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Ekki tókst að bæta " + data.name + " við vörumerki",
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.POST("brands/", data, success, failure);
    }

    onAddType(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.name+" bætt við í tegundir",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetTypes();
        }.bind(this);

        var failure = function(error) {
            console.error("addTypes() fail", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta "+data.name+" við tegundir",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("types/", data, success, failure);
    }

    onAddLocation(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.name+" bætt við í staðsetningar",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetLocations();
        }.bind(this);

        var failure = function(error) {
            console.error("addLocation() fail", error);
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta "+data.name+" við staðsetningar",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("locations/", data, success, failure);
    }

    onAddUser(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.username+" bætt við í notendur",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetUsers();
        }.bind(this);
        var failure = function(error) {
            console.error("addUser() fail", error);
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta "+data.username+" við notendur",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("users/", data, success, failure);
    }

    onAddUserDepartmentAccess(data) {

        var success = function(result) {
            this.onGetDepartmentAccess();
        }.bind(this);
        var failure = function(error) {
            console.error("addUserDepartmentAccess() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta við deildaraðgang á notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("departmentaccess/", data, success, failure);
    }

    onAddRole(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: data.name+" bætt við í hlutverk",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetRoles();
        }.bind(this);
        var failure = function(error) {
            console.error("addRole() fail", error)
            var newState = {};
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta við hlutverki",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("roles/", data, success, failure);
    }

    onAddRolesPerUser(data) {

        var success = function(result) {
            this.onGetRolesPerUser();
            var notification = {
                title: "Aðgerð tókst!",
                message: "Tókst að bæta við hlutverki á notanda",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);
        var failure = function(error) {
            console.error("addRolesPerUser() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að bæta við hlutverki á notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.POST("rolesperuser/", data, success, failure);
    }

    // ================
    // UPDATE FUNCTIONS
    // ================

    onUpdateDepartment(data) {
      var sortedDepartments = _.indexBy(this.departments, "id");

      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: sortedDepartments[data.id].name+" hefur verið breytt",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetDepartments();
      }.bind(this);
      var failure = function(error) {
        console.error("updateDepartment() fail", error)

        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Ekki tókst að breyta "+sortedDepartments[data.id].name,
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.PUT("departments/" + data.id + "/", data.body, success, failure);
    }

    onUpdateBrand(data) {
      var sortedBrands = _.indexBy(this.brands, "id");

      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: sortedBrands[data.id].name + " hefur verið breytt",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetBrands();
      }.bind(this);
      var failure = function(error) {
        console.error("updateBrand() fail", error)

        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: "Ekki tókst að breyta " + sortedDepartments[data.id].name,
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.PUT("brands/" + data.id + "/", data.body, success, failure);
    }

    onUpdateType(data) {
        var sortedTypes = _.indexBy(this.types, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedTypes[data.id].name+" hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetTypes();
        }.bind(this);
        var failure = function(error) {
            console.error("updateType() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta "+sortedTypes[data.id].name,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("types/"+data.id+"/", data.body, success, failure);
    }

    onUpdateLocation(data) {
        var sortedLocations = _.indexBy(this.locations, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedLocations[data.id].name+" hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetLocations();
        }.bind(this);
        var failure = function(error) {
            console.error("updateLocation() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta "+sortedLocations[data.id].name,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("locations/"+data.id+"/", data.body, success, failure);
    }

    onUpdateUser(data) {
        var sortedUsers = _.indexBy(this.users, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedUsers[data.id].username+" hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetUsers();
        }.bind(this);
        var failure = function(error) {
            console.error("updateUser() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta "+sortedUsers[data.id].username,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("users/"+data.id+"/", data.body, success, failure);
    }

    onUpdateUserDepartmentAccess(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: "Deildaraðgang notanda hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetDepartmentAccess();
        }.bind(this);
        var failure = function(error) {
            console.error("updateUserDepartmentAccess() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta deildaraðgang notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("departmentaccess/"+data.id+"/", data.body, success, failure);
    }

    onUpdateRole(data) {
        var sortedRoles = _.indexBy(this.roles, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedRoles[data.id].name+" hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetRoles();
        }.bind(this);
        var failure = function(error) {
            console.error("updateRole() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta "+sortedRoles[data.id].name,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("roles/"+data.id+"/", data.body, success, failure);
    }

    onUpdateRolesPerUser(data) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: "Hlutverki notanda hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetRolesPerUser();
        }.bind(this);
        var failure = function(error) {
            console.error("updateRolesPerUser() fail", error)

            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta hlutverki notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.PUT("rolesperuser/"+data.id+"/", data.body, success, failure);
    }

    // ================
    // DELETE FUNCTIONS
    // ================

    onDeleteDepartment(id) {
      var sortedDepartments = _.indexBy(this.departments, "id");

      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: sortedDepartments[id].name+" hefur verið eytt",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetDepartments();
      }.bind(this);
      var failure = function(error) {
        console.error("deleteDepartment() fail", error)

        var message = "Ekki tókst að eyða "+sortedDepartments[id].name;
        if (error.responseJSON.detail && error.responseJSON.detail !== "") {
          message = error.responseJSON.detail;
        }
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: message,
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.DELETE("departments/"+id+"/", success, failure);
    }

    onDeleteBrand(id) {
      var sortedBrands = _.indexBy(this.brands, "id");

      var success = function(result) {
        var notification = {
          title: "Aðgerð tókst!",
          message: sortedBrands[id].name + " hefur verið eytt",
          level: 'success'
        }
        NotificationActions.createNotification(notification);
        this.onGetBrands();
      }.bind(this);
      var failure = function(error) {
        console.error("deleteBrand() fail", error)

        var message = "Ekki tókst að eyða " + sortedBrands[id].name;
        if (error.responseJSON.detail && error.responseJSON.detail !== "") {
          message = error.responseJSON.detail;
        }
        var notification = {
          title: "Eitthvað fór úrskeiðis!",
          message: message,
          level: 'error'
        }
        NotificationActions.createNotification(notification);
      }.bind(this);

      Networking.DELETE("brands/" + id + "/", success, failure);
    }

    onDeleteType(id) {
        var sortedTypes = _.indexBy(this.types, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedTypes[id].name+" hefur verið eytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetTypes();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteTypes() fail", error)

            var message = "Ekki tókst að eyða "+sortedTypes[id].name;
            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("types/"+id+"/", success, failure);
    }

    onDeleteLocation(id) {
        var sortedLocations = _.indexBy(this.locations, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedLocations[id].name+" hefur verið eytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetLocations();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteLocation() fail", error)

            var message = "Ekki tókst að eyða "+sortedLocations[id].name;
            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("locations/"+id+"/", success, failure);
    }

    onDeleteUser(id) {
        var sortedUsers = _.indexBy(this.users, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedUsers[id].username+" hefur verið eytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetUsers();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteUser() fail", error)

            var message = "Ekki tókst að eyða "+sortedUsers[id].username;
            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("users/"+id+"/", success, failure);
    }

    onDeleteUserDepartmentAccess(id) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: "Deildaraðgang notanda hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetDepartmentAccess();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteUserDepartmentAccess() fail", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta deildaraðgang notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("departmentaccess/"+id+"/", success, failure);
    }

    onDeleteRole(id) {
        var sortedRoles = _.indexBy(this.roles, "id");

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: sortedRoles[id].name+" hefur verið eytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetRoles();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteRole() fail", error)
            var message = "Ekki tókst að eyða "+sortedRoles[id].name;
            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: message,
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("roles/"+id+"/", success, failure);
    }

    onDeleteRolesPerUser(id) {

        var success = function(result) {
            var notification = {
                title: "Aðgerð tókst!",
                message: "Hlutverki notanda hefur verið breytt",
                level: 'success'
            }
            NotificationActions.createNotification(notification);
            this.onGetRolesPerUser();
        }.bind(this);
        var failure = function(error) {
            console.error("deleteRolesPerUser() fail", error)
            var notification = {
                title: "Eitthvað fór úrskeiðis!",
                message: "Ekki tókst að breyta hlutverki notanda",
                level: 'error'
            }
            NotificationActions.createNotification(notification);
        }.bind(this);

        Networking.DELETE("rolesperuser/"+id+"/", success, failure);
    }
});

window.companyStore = companyStore;

module.exports = companyStore;



// WEBPACK FOOTER //
// ./app/scripts/stores/CompanyStore.js